module.exports = {
    landcoverClasses: {
        "HID": {
            "name": "Developed, High Intensity",
        },
        "MID": {
            "name": "Developed, Medium Intensity",
        },
        "LID": {
            "name": "Developed, Low Intensity",
        },
        "OSD": {
            "name": "Developed, Open Space",
        },
        "GRS": {
            "name": "Grassland/Herbaceous",
        },
        "SHB": {
            "name": "Scrub/Shrub",
        },
        "BAR": {
            "name": "Bare Land",
        },
        "WTR": {
            "name": "Open Water",
        },
        "AGR": {
            "name": "Agriculture",
        },
        "FOR": {
            "name": "Forested",
        },
        "WDW": {
            "name": "Woody Wetland",
        },
        "EMW": {
            "name": "Emergent Wetland",
        },
        "DEC": {
            "name": "Deciduous Forest"
        },
        "EVR": {
            "name": "Evergreen Forest"
        },
        "MXF": {
            "name": "Mixed Forest"
        },
        "WET": {
            "name": "Wetlands"
        },
        "DEV": {
            "name": "Development"
        },
        "PFW": {
            "name": "Palustrine Forested Wetland",
        },
        "EHW": {
            "name": "Emergent Herbaceous Wetland",
        },
        "EFW": {
            "name": "Estuarine Forested Wetland",
        },
        "ESW": {
            "name": "Estuarine Scrub/Shrub Wetland",
        },
        "EEW": {
            "name": "Estuarine Emergent Wetland",
        },
        "USR": {
            "name": "Unconsolidated Shore",
        },
        "ICE":{
            "name":"Perennial Ice/Snow",
        },
        "BRN":{
            "name":"Barren Land",
        },
        "DFO":{
            "name":"Deciduous Forest",
        },
        "EFO":{
            "name":"Evergreen Forest",
        },
        "MFO":{
            "name":"Mixed Forest",
        },
        "SHB":{
            "name":"Shrub/Scrub",
        },
        "PAS":{
            "name":"Pasture/Hay",
        },
        "CRP":{
            "name":"Cultivated Crops",
        },        
        "PIS":{
            "name":"Perennial Ice/Snow",
        }
    }
}
